import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { getHtmlLangAttribute } from 'app/core/i18n/app-locale';

/**
 * Sends `Accept-Language: vi|en` on every `/api/` request (kb#2605).
 *
 * `neraLanguageInterceptor` only sets `X-Language` carrying Transloco's id
 * (`vn`), but be-app resolves the response locale from `Accept-Language`
 * alone, so Vietnamese UIs received English copy. `Accept-Language` is a
 * CORS-safelisted request header (no preflight), so the SPA can set it. The
 * Transloco id `vn` is mapped to the BCP-47 tag `vi`. Same `/api/` scope as
 * `neraLanguageInterceptor`; a caller-supplied `Accept-Language` wins.
 */
export const acceptLanguageInterceptor: HttpInterceptorFn = (req, next) => {
    if (!req.url.includes('/api/') || req.headers.has('Accept-Language')) {
        return next(req);
    }
    const lang = getHtmlLangAttribute(inject(TranslocoService).getActiveLang());
    return next(req.clone({ headers: req.headers.set('Accept-Language', lang) }));
};
